export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_JQ7zyMc4k',
      userPoolWebClientId: '27r12j9i41pi0f3vveg5tjdaqi',
      identityPoolId: 'us-east-1:4ce49aeb-1f96-4c2b-bd0a-eca07eec8cce',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: "code",
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAcces: true,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  }
};

export const environment = {
  production: true,
  apiUrl: 'https://6yi6za5746.execute-api.us-east-1.amazonaws.com/prod-v2',
  apiAdmin: 'https://6yi6za5746.execute-api.us-east-1.amazonaws.com/prod-v2/hostings/list',
  apiRecep: 'https://6yi6za5746.execute-api.us-east-1.amazonaws.com/prod-v2/hostIds/list',
  apiUrlLanding: 'https://j8o2tlx5lb.execute-api.us-east-1.amazonaws.com/prod-v2',
  uploadApiUrl: 'https://6yi6za5746.execute-api.us-east-1.amazonaws.com/prod-v2/upload',
  openStreetMapUrl: 'https://nominatim.openstreetmap.org/reverse?format=json',
  uploadReservationDocumentsUrl: 'https://6yi6za5746.execute-api.us-east-1.amazonaws.com/prod-v2/calculations/reservations',
  mercadoPagoUrl: 'https://x1j3qyw4b6.execute-api.us-east-1.amazonaws.com/create-payment',
  endingPaymentUrl: 'https://x1j3qyw4b6.execute-api.us-east-1.amazonaws.com/webhook',
  hostingApiUrl: 'https://j8o2tlx5lb.execute-api.us-east-1.amazonaws.com/prod-v2/hosting',
  availabilityApiUrl: 'https://k6ms7uwv62.execute-api.us-east-1.amazonaws.com/prod-v2/calculations',
  region: 'us-east-1',
  s3BucketImages: 'ecoturismo-images-prod',
  userPoolId: 'us-east-1_JQ7zyMc4k',
  clientId: '27r12j9i41pi0f3vveg5tjdaqi',
  identityPoolId: 'us-east-1:4ce49aeb-1f96-4c2b-bd0a-eca07eec8cce',
  dbEndpoint: 'ecoturismo2025.cdjwgh9lczq3.us-east-1.rds.amazonaws.com',
  cloudfrontUrl: 'https://d24mcqad68edbz.cloudfront.net',
  amazonLocation: {
    region: 'us-east-1',
    mapName: 'MapaDireccionUsuario',
    accessToken: 'v1.public.eyJqdGkiOiI1YzI5MmJmNi1lNGU5LTRlYTYtYTg5YS1kYTY0YWFkYzUyZDgifVij1-Age6Rf9uN9OHJHwNmYFmkYxjf_oNtd2Ht1KbiLEx-NMOtUMBKuiQZHMoqmZRFr5ClJZOsC3wNlB-gneq2T7ewZElScG9cobuEoDretUFG76iD-6CFOb8rpbeSUm_j9aj_y9DAm0j33zsdvPNdwnAzZm8Y0ES6gDxtW-L0kZAOVk2R91gwo-2dsiJwClGcUJjXEe_9dpCS7wnsRk8XNqnNsR_93rtRisDHaj8mS7l0YdV7Fz7crqf1FCHndhbDafHRcN-Lzz-ll7Xo1i__OEqT5RIXf6dYuxPffBLF-tXQttR3t1pVpPobJzH6xWPiwiZnKz8gr0XjBu3fnoFg.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx'
  }
};
